<template>
  <div>
    <table class="table table-sm">
      <thead>
        <tr>
          <th colspan="2" style="border-bottom:0px"></th>
          <th colspan="2" style="text-align:center;border-bottom:0px">Dernière mise à jour</th>
        </tr>
        <tr>
          <th>Fournisseurs</th>
          <th>Statut</th>
          <th style="text-align:center;border-top:0px">Fournisseur</th>
          <th style="text-align:center;border-top:0px">Agent</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='service_provider in serviceproviders' class="row-hover" :key="service_provider.service_provider_id">
          <router-link class="nav-link" tag="td" v-text="service_provider.agency" :to="{ name: 'sp_tableaudebord', params: { service_provider_id: service_provider.service_provider_id}}"></router-link>
          <router-link class="nav-link" tag="td" v-text="service_provider.status" :to="{ name: 'sp_tableaudebord', params: { service_provider_id: service_provider.service_provider_id}}"></router-link>
          <router-link class="nav-link" tag="td" style="text-align:center" v-text="service_provider.rsf_modified_at" :to="{ name: 'sp_tableaudebord', params: { service_provider_id: service_provider.service_provider_id}}"></router-link>
          <router-link class="nav-link" tag="td" style="text-align:center" v-text="service_provider.za_modified_at" :to="{ name: 'sp_tableaudebord', params: { service_provider_id: service_provider.service_provider_id}}"></router-link>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MyServiceProviders',
  props: {
    serviceproviders: {},
  },

}
</script>
